
import Experience from './InteractiveMap/Experience.js'


// Passer la div a l'experience
//! LA DIV DOIT AVOIR L'id MAP obligatoirement
// Canvas
const container = document.querySelector('div#map')

const pathologiesArray = ["cancer1", "cancer2", "cancer3"]
const countriesArray = ["pays1", "pays2", "pays3"]
const expertisesArray = ["expertise1", "expertise2", "expertise3"]
const filters = [pathologiesArray, countriesArray, expertisesArray]

const experience = new Experience(container, filters)

